import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *已选中列表
 * @param params
 * 
*/

export const pickList = params => Http.get(`${baseUrl}/activity/pick`, { params })

/**
 *选人
 * @param activityId 
 * 
*/

export const pick = activityId => Http.post(`${baseUrl}/activity/pick/${activityId}`)

/**
 *选人
 * @param pickId 
 * 
*/

export const delPick = pickId => Http.delete(`${baseUrl}/activity/pick/${pickId}`)
